















































import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import Network from '@/js/Network'
import ListPage from './ListPage.vue'
import { DEFAULT_NETWORK_ID } from '@/store/modules/network/network'

@Component({
    components: {
        ListPage,
    },
})
export default class NetworkMenu extends Vue {
    page = 'list' // list, custom, edit (disabled)
    isModalOpen = false

    toggleMenu(): void {
        this.isModalOpen = !this.isModalOpen
    }

    viewList(): void {
        this.page = 'list'
    }

    closeMenu(): void {
        this.page = 'list'
        this.isModalOpen = false
    }

    get status(): string {
        return this.$store.state.Network.status
    }

    get activeNetwork(): Network | null {
        return this.$store.state.Network.selectedNetwork
    }

    get networks(): Network {
        return this.$store.state.Network.networks
    }

    get networkColor(): string {
        return DEFAULT_NETWORK_ID === 1 ? 'primary' : 'white'
    }
}
